<template>
    <div layout="column">
        <div layout="column" class="pa3-pc pa1-mobile bg-white">
            <div class="headline font-weight-bold">{{$t('nav.settings')}}</div>
            <div layout="row" layout-align="start center" layout-wrap class="mt-2">
                <span @click.prevent="$router.push({name: 'admin-settings-users-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-users') == 0}">{{$t('params.users')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-langs-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-langs') == 0}">{{$t('params.langs')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-regional-directorates-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-regional-directorates') == 0}">{{$t('params.rds')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-regions-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-regions') == 0}">{{$t('params.regions')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-cycles-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-cycles') == 0}">{{$t('params.cycles')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-regimes-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-regimes') == 0}">{{$t('params.regimes')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-age-groups-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-age-groups') == 0}">{{$t('params.ags')}}</span>
                <span class="grey--text ml-2 mr-2">|</span>
                <span @click.prevent="$router.push({name: 'admin-settings-values-index'})" class="clickable" :class="{'active-param' : $route.name.indexOf('admin-settings-values') == 0}">{{$t('params.config')}}</span>
            </div>
        </div>
        <router-view name="adminbody" class="mt3-pc mt2-mobile" flex></router-view>
    </div>
</template>

<script>
    export default {}
</script>
<style scoped>
    .active-param{
        font-weight: bold;
        color: #2E3B7F;
    }
</style>